import sanitizeHtml, { IOptions } from 'sanitize-html';

export const SANITIZE_HTML_DEFAULT_OPTIONS: IOptions = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a'],
  allowedAttributes: {
    a: ['href'],
    '*': ['style'],
  },
};

export const sanitize = (dirty, options = {}) =>
  sanitizeHtml(dirty, { ...SANITIZE_HTML_DEFAULT_OPTIONS, ...options });

export const sanitizeInnerHtml = (dirty, options = {}) => ({
  __html: sanitize(dirty, options),
});
